import axios from "axios";
import { toast } from "react-toastify";

export async function uploadImageToCMS(file, token) {
  if (!file) return null;

  const allowedTypes = ["image/png", "image/jpeg"];

  if (!allowedTypes.includes(file.type)) {
    toast.error("Sadece PNG veya JPG yükleyebilirsiniz.");
    return null;
  }

  const formData = new FormData();
  formData.append("FormFile", file);
  formData.append("Folder", "videointeraction");
//   formData.append("FileName",file.name);

  try {
    const response = await axios.post(
      "https://contentprocess.tosanalytics.com/devtest/api/mediafile/uploads",
      formData,
      {
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "multipart/form-data"
        }
      }
    );

    if (response.data.responseStatus === 0) {
      toast.error(response.data.responseMessage);
      return null;
    }

    return response.data.responseData[0].imageUrl;

  } catch (err) {
    console.error("Upload error:", err);
    toast.error("Dosya yüklenemedi.");
    return null;
  }
}
